import { render, staticRenderFns } from "./ScreenRecordingWatermark.vue?vue&type=template&id=8dda11fa&scoped=true"
import script from "./ScreenRecordingWatermark.vue?vue&type=script&lang=js"
export * from "./ScreenRecordingWatermark.vue?vue&type=script&lang=js"
import style0 from "./ScreenRecordingWatermark.vue?vue&type=style&index=0&id=8dda11fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dda11fa",
  null
  
)

export default component.exports